import {initializeApp} from 'firebase/app'
import {getAuth, GoogleAuthProvider} from 'firebase/auth'

export const firebaseConfig = {

	apiKey: "AIzaSyAaj1hhc_gNI-c_MKjsNNt6ZUOZHfzmNk0",

	authDomain: "logiclovers-3bc59.firebaseapp.com",

	projectId: "logiclovers-3bc59",

	storageBucket: "logiclovers-3bc59.firebasestorage.app",

	messagingSenderId: "738421457202",

	appId: "1:738421457202:web:8e1f2de96059fb408cd72b"

};
export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
